<template>
  <section class="w-100 bg-bar">
    <div class="container">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <p class="text-white m-0">Todos os direitos reservados VirteX LTDA.</p>
        <a
          href=""
          @click.prevent="contractDialog = true"
          class="text-white border rounded p-1 d-flex text-decoration-none align-items-center"
        >
          <i class="material-icons mr-1">description</i>
          <span class="mr-1">Contrato</span>
        </a>
      </div>
    </div>
    <md-dialog :md-active.sync="contractDialog">
      <md-dialog-title>Contrato</md-dialog-title>
      <md-dialog-content>
        <a
          href="/contratos/AVERBACAO_DE_ADITIVO_DE_CONTRATO_DE_PRESTACAO_DE_SERVICO_VIRTEX.pdf"
          class="d-flex text-decoration-none align-items-center"
          download
        >
          <i class="material-icons mr-1">description</i>
          <span class="mr-1">AVERBACÃO DE ADITIVO DE CONTRATO DE PRESTAÇÃO DE SERVIÇO VIRTEX</span>
        </a>
        <a
          href="/contratos/CONTRATO_DE_PRESTACAO_DE_SERVICOS_VIRTEX.pdf"
          class="d-flex text-decoration-none align-items-center"
          download
        >
          <i class="material-icons mr-1">description</i>
          <span class="mr-1">CONTRATO DE PRESTAÇÃO DE SERVIÇOS VIRTEX TELECOM</span>
        </a>
        <a
          href="/contratos/TERMO_DE_CONTRATACAO_E_FIDELIDADE.pdf"
          class="d-flex text-decoration-none align-items-center"
          download
        >
          <i class="material-icons mr-1">description</i>
          <span class="mr-1">TERMO DE CONTRATAÇÃO E FIDELIDADE</span>
        </a>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="contractDialog = false">Fechar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </section>
</template>

<script>
export default {
  name: "BarEndSite",
  data() {
    return {
      contractDialog: false
    };
  }
};
</script>

<style scoped>
.bg-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #0f0f0f;
  height: 80px;
}
</style>
